export default __webpack_public_path__ + "static/media/icon_time_white.268b424e.svg";